async function openGorgiasChat() {
  try {
    if (window.initGorgiasChatPromise) {
      await window.initGorgiasChatPromise;
    }

    if (window.GorgiasChat?.open) {
      window.GorgiasChat.open();
      return;
    }

    console.warn("GorgiasChat not ready yet.");
  } catch (err) {
    console.warn("Failed to initialize GorgiasChat.", err);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const chatBtn = document.getElementById("open-gorgias-chat");
  if (!chatBtn) return;

  chatBtn.addEventListener("click", async (e) => {
    e.preventDefault();

    await openGorgiasChat();
  });
});